module.exports = __webpack_public_path__ + "img/20191216161953360截图20191216105352988.0e9791fe.jpg";